module.exports = __webpack_public_path__ + "static/container-4149e2367de87aa267332839e50b81e2.gif";